import React from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex flex-col bg-cream" data-testid="payment-cancel-page">
      <Header />
      <section className="max-w-2xl mx-auto px-5 py-24 text-center">
        <h1 className="editorial font-serif-display text-4xl sm:text-5xl text-plum-deep">Checkout cancelled</h1>
        <p className="mt-4 text-plum/70">No worries — your cart has been saved. You can resume whenever you're ready.</p>
        <div className="mt-8 flex gap-3 justify-center flex-wrap">
          <Link to="/checkout" className="btn-primary" data-testid="resume-checkout-btn">Resume checkout</Link>
          <Link to="/shop" className="btn-ghost-gold">Back to shop</Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
